import React, { useState, useEffect } from 'react';
import heroImage from '../assets/images/jetblack-bg.png';

const MobileReserveRide = () => {
  // Animación para la tarjeta (que contiene el iframe)
  const [cardAnimation, setCardAnimation] = useState({
    transform: 'translateY(50px) scale(0.95)',
    opacity: 0,
  });

  // Animación adicional para el iframe dentro de la tarjeta (efecto escalonado)
  const [iframeAnimation, setIframeAnimation] = useState({
    transform: 'translateY(30px) scale(0.95)',
    opacity: 0,
  });

  // Al montar el componente, se dispara la animación para mostrar la tarjeta
  useEffect(() => {
    const timeout = setTimeout(() => {
      setCardAnimation({
        transform: 'translateY(0) scale(1)',
        opacity: 1,
      });
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  // Animación del iframe con un pequeño retraso adicional para efecto escalonado
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIframeAnimation({
        transform: 'translateY(0) scale(1)',
        opacity: 1,
      });
    }, 400);
    return () => clearTimeout(timeout);
  }, []);

  // Estilos en línea
  const containerStyle = {
    padding: '0',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f7f7f7',
    minHeight: '100vh',
  };

  // Imagen de cabecera ocupando el 100% del ancho
  const imageStyle = {
    width: '100%',
    height: 'auto',
    display: 'block',
  };

  // Estilo del título y párrafo
  const headingStyle = {
    textAlign: 'center',
    color: '#0d2b3e',
    margin: '20px 0 10px 0',
    fontSize: '3rem',
    textTransform: 'uppercase',
    letterSpacing: '4px',
    textShadow: '4px 4px 10px rgba(0, 0, 0, 0.4)',
    fontWeight: '900',
  };

  const paragraphStyle = {
    textAlign: 'justify',
    maxWidth: '90%',
    margin: '0 auto 20px auto',
    color: '#333',
    fontSize: '1rem',
    lineHeight: '1.6',
  };

  // Estilo de la tarjeta con un efecto 3D más pronunciado y mayor separación (más larga)
  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '25px', // Mayor padding interno para que se vea más espacioso
    maxWidth: '90%',
    margin: '0 auto 80px auto', // Mayor margen inferior para separar del pie de página
    transition: 'transform 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55), opacity 0.7s ease',
    // Efecto 3D aumentado: sombra doble más intensa
    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3), 0 10px 30px rgba(0, 0, 0, 0.25)',
    ...cardAnimation,
  };

  // Estilo del iframe con animación adicional; se aumenta la altura para que la tarjeta sea más larga
  const iframeStyle = {
    width: '100%',
    height: '600px', // Mayor altura para extender el formulario
    border: 'none',
    borderRadius: '8px',
    transition: 'transform 0.7s ease, opacity 0.7s ease',
    ...iframeAnimation,
  };

  return (
    <div style={containerStyle}>
      {/* Imagen de cabecera */}
      <img src={heroImage} alt="Jet Black" style={imageStyle} />

      {/* Contenedor del título y descripción */}
      <div style={{ padding: '20px' }}>
        <h2 style={headingStyle}>Reserve Your Ride with Jet Black</h2>
        <p style={paragraphStyle}>
          Experience the ultimate in luxury and style with our exclusive reservation system.
          Book your ride now and enjoy a seamless, personalized service tailored just for you.
          Let Jet Black elevate your travel experience.
        </p>
      </div>

      {/* Tarjeta con el formulario de reserva, animación y efecto 3D mejorado */}
      <div style={cardStyle}>
        <iframe
          src="https://bookridesonline.com/book/?dbaid=a0QxYhwasvAMbYgsQXPG0g%3d%3d"
          title="Booking Form"
          style={iframeStyle}
        ></iframe>
      </div>
    </div>
  );
};

export default MobileReserveRide;
